<template>
  <div class="wrap-content">
    <div class="content-wrap">
      <el-card>
        <span class="tip">
          <i class="iconfont iconInfo-Solid"></i>
          {{ $t('system::team::auth_data_tip') }}
        </span>
        <el-checkbox-group v-model="selectList" @change="change" class="content" v-loading="loading">
          <el-checkbox class="check-item" :label="-1">{{ $t('system::team::all_shop') }}</el-checkbox>
          <template v-for="(item, index) in merchants">
            <el-checkbox class="check-item" :label="item.id" :disabled="disabled" :key="index">
              {{ item.name }}
            </el-checkbox>
          </template>
        </el-checkbox-group>
        <div style="text-align:end;margin-top:10px">
          <el-button :loading="sumbitLoading" @click="sumbit" type="primary" size="small" style="width:90px">
            {{ $t('system::common::btn::save') }}
          </el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getShopList } from '@/server/shopList'
import { teamAuthList, teamAuthUpdate } from '@/server/team-manage'
import { getMerchantType } from '@/server/user'
import { getErpMerchant } from '@/server/data'
export default {
  props: {
    roleId: {
      default: '',
      type: [Number, String]
    },
    selected: {
      default: () => {}
    }
  },
  watch: {
    selected: {
      handler: function(data) {
        this.getDataAuthList()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      merchants: [],
      selectList: [],
      loading: false,
      sumbitLoading: false
    }
  },
  async mounted() {
    await this.getMerchantType()
  },
  computed: {
    disabled() {
      return (this.selectList || []).some(el => el === -1)
    }
  },
  methods: {
    search() {
      this.getDataAuthList()
    },
    async getMerchantType() {
      const { data } = await getMerchantType(this.$store.state.user.merchantId)
      if (data.code === this.$code) {
        if (data.data === 1) {
          await this.getMerchant()
        } else if (data.data === 2) {
          await this.getErpMerchant()
        }
      }
    },
    async getMerchant() {
      this.loading = true
      const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
      if (data.code === this.$code) {
        this.merchants = data.data.items || []
      }
      this.loading = false
    },
    async getErpMerchant() {
      this.loading = true
      const { data } = await getErpMerchant({ merchantId: this.$store.state.user.merchantId })
      if (data.code === this.$code) {
        this.merchants = data.data.datas.map(el => {
          return { name: el.shopName, id: Number(el.shopId) }
        })
      }
      this.loading = false
    },
    async getDataAuthList() {
      this.loading = true
      const data = await teamAuthList(this.selected.id)
      if (data.data.code === this.$code) {
        this.selectList = data.data.data.data[0].datas || []
      }
      this.loading = false
    },
    change() {
      if (this.disabled) {
        this.selectList = [-1]
      }
    },
    async sumbit() {
      this.sumbitLoading = true
      const data = await teamAuthUpdate([{ teamId: this.selected.id, dataType: 1, authorizeDataIds: this.selectList }])
      if (data.data.code === this.$code) {
        this.$message.success(this.$t('system::tip::save_success'))
      }
      this.sumbitLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
.tip {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 12px;
  margin: 16px 0;
  .iconInfo-Solid {
    color: #999;
    font-size: 14px;
    margin-right: 4px;
  }
}
.check-item {
  margin-right: 40px;
  margin-bottom: 20px;
}
.content {
  overflow: auto;
  height: 465px;
}
</style>
